import rembeLogo from '../../assets/BWT_LOGO.png'
import { GeneralTexts, OtherTexts } from '../../language/Texts'
import './Footer.scss'

function Footer() {
    const footerLinks = [
        {
            name: 'BWT.com',
            url: OtherTexts.bwtWebsite
        },
        {
            name: GeneralTexts.imprint,
            url: OtherTexts.imprintUrl
        },
        {
            name: GeneralTexts.dataSecurity,
            url: 'https://www.bwt.com/de-ch/datenschutz/'
        },
        {
            name: GeneralTexts.termOfUse,
            url: 'https://www.bwt.com/de-ch/agb/'
        },
        {
            name: 'powered by conexo',
            url: 'https://inevvo-solutions.com/'
        }
    ]

    const linkList = () => footerLinks.map((item, index) => <a key={index} className='footer_link' target='_blank' href={item.url}>{item.name}</a>)

    return (
        <div className='footer_wrapper'>
            <div className="links_wrapper">
                {linkList()}
            </div>
            <div className="footer_logo_text_wrapper">
                <a href={OtherTexts.bwtWebsite} target='_blank'>
                    <img className='footer_logo' src={rembeLogo} alt="rembeLogo" />
                </a>
                <div className="logo_text">© REMBE® GmbH Safety+Control </div>
            </div>

        </div>
    )
}

export default Footer
